import AuthGuard from '@/components/layout/AuthGuard';
import { ROUTES } from '@/constants/routes';
import { lazy, Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import PageLoader from './components/ui/Loader/PageLoader';
import { useRemoteConfig } from './hooks/firebase/useRemoteConfig';
const Forbidden = lazy(() => import('@/pages/Forbidden'));
const Home = lazy(() => import('@/pages/Home/Home'));
const Login = lazy(() => import('@/pages/Login/Login'));
const NotFound = lazy(() => import('@/pages/NotFound'));
const ServerError = lazy(() => import('@/pages/ServerError'));
const ScheduleADemo = lazy(() => import('./pages/ScheduleADemo/ScheduleADemo'));

const Dashboard = lazy(() => import('./pages/Dashboard/Dashboard'));
const UploadFiles = lazy(() => import('./pages/UploadFiles/UploadFiles'));
const UserManagement = lazy(
  () => import('./pages/UserManagement/UserManagement')
);
const Documents = lazy(() => import('./pages/Documents/Documents'));
const IndividualDocument = lazy(
  () => import('./pages/IndividualDocument/IndividualDocument')
);
const Templates = lazy(() => import('./pages/Templates/Templates'));
const RecordsPage = lazy(() => import('./pages/Records/Records'));
const UserGuide = lazy(() => import('./pages/UserGuides/UserGuide'));

function RemoteConfigWrapper({ children }: { children: React.ReactNode }) {
  useRemoteConfig({ listenForUpdates: true });
  return <>{children}</>;
}

const router = createBrowserRouter([
  {
    path: ROUTES.HOME,
    element: <Home />,
  },
  {
    path: ROUTES.SCHEDULE_A_DEMO,
    element: <ScheduleADemo />,
  },
  {
    element: <AuthGuard />,
    children: [
      {
        path: ROUTES.LOGIN,
        element: <Login />,
      },
    ],
  },
  {
    element: <AuthGuard requireAuth />,
    children: [
      {
        path: ROUTES.DASHBOARD,
        element: <Dashboard />,
      },
      {
        path: ROUTES.UPLOAD_FILES,
        element: <UploadFiles />,
      },
      {
        path: ROUTES.USER_MANAGEMENT,
        element: <UserManagement />,
      },
      {
        path: ROUTES.DOCUMENT_DETAIL,
        element: <IndividualDocument />,
      },
      {
        path: ROUTES.TEMPLATES,
        element: <Templates />,
      },
      {
        path: ROUTES.DOCUMENTS,
        element: <Documents />,
      },
      {
        path: ROUTES.RECORDS,
        element: <RecordsPage />,
      },
      {
        path: ROUTES.USER_GUIDES,
        element: <UserGuide />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
  {
    path: ROUTES.FORBIDDEN,
    element: <Forbidden />,
  },
  {
    path: ROUTES.SERVER_ERROR,
    element: <ServerError />,
  },
]);

function App() {
  return (
    <RemoteConfigWrapper>
      <Suspense fallback={<PageLoader />}>
        <RouterProvider router={router} />
      </Suspense>
    </RemoteConfigWrapper>
  );
}

export default App;
